<script setup>
import LinkNormal from '@/components/links/LinkNormal.vue';
</script>

<template>
  <div
    id="page"
    class="flex min-h-full flex-col justify-center bg-gray-50 pt-12">
    <div class="flex grow flex-col justify-center px-4 sm:px-6 lg:px-8">
      <slot />
    </div>

    <footer class="mt-16 space-y-0.5 py-4 pl-4 pr-16 text-xs">
      <p>
        Use of Traxo is bound by our
        <LinkNormal
          as="a"
          href="https://www.traxo.com/agreement">
          User Agreement.
        </LinkNormal>
      </p>
    </footer>
  </div>
</template>
